export default () => ({
  taxi: null,
  taxiList: [],
  taxiFilterList: [],
  taxiSignatureData: { signatureSrc: null },
});
